module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1790221230673.png";